import { format } from "date-fns";
import { FORM_KEYS } from "../helper";
import { OTHERS } from "../HospitalizationDetails";
import { Accordion } from "react-bootstrap";

const ExistingPolicyDetails = ({ formData }) => {
    return <>
        <h6 className="mt-4 mx-2">Other Existing Health Policy Details </h6>
        <hr className="m-0 p-0" />
        <div className="row mt-3 px-2">
            <div className="col-xl-12">
                <p className="label">
                    Do you have any other existing health policies?
                </p>
                <p className="value">
                    {formData[FORM_KEYS.have_other_policies] || "--"}
                </p>
            </div>
        </div>
        {
            formData[FORM_KEYS.have_other_policies] === "Yes" ? (
                <>
                    {formData.existingPolicyDetails?.map((policyDetails, index) => (
                        <Accordion className='accordion mb-2'>
                            <Accordion.Item eventKey={index}>
                                <Accordion.Header>
                                    Policy - {index + 1}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="row mt-1 px-2">
                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                            <p className="label">
                                                Policy Number
                                            </p>
                                            <p className="value">
                                                {policyDetails[FORM_KEYS.policy_number] || "--"}
                                            </p>
                                        </div>
                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                            <p className="label">
                                                Insurer Name
                                            </p>
                                            <p className="value">
                                                {policyDetails[FORM_KEYS.insurer_name] || "--"}
                                            </p>
                                        </div>
                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                            <p className="label">
                                                Sum Insured (₹)
                                            </p>
                                            <p className="value">
                                                {policyDetails[FORM_KEYS.sum_insured] || "--"}
                                            </p>
                                        </div>
                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                            <p className="label">
                                                Coverage Type
                                            </p>
                                            <p className="value">
                                                {policyDetails[FORM_KEYS.coverage_type]?.label || "--"}
                                            </p>
                                        </div>

                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                            <p className="label">
                                                Policy Validity
                                            </p>
                                            <p className="value">                                            
                                                {policyDetails[FORM_KEYS.policy_start_date] ? format(policyDetails[FORM_KEYS.policy_start_date], "dd-MM-yyyy") : "--"}
                                                {" - "}
                                                {policyDetails[FORM_KEYS.policy_end_date] ? format(policyDetails[FORM_KEYS.policy_end_date],"dd-MM-yyyy") : "--"}
                                            </p>
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    ))}

                </>
            ) : ""
        }
    </>
}
export default ExistingPolicyDetails;